module.exports = (fox, $) => {
    'use strict';

    const getTranslation = (alias, mod) => {
		const translation = {
			'cookieConsentManagerTitle': fox.i18n.getTranslation('cookieConsentManagerTitle', 'Cookies consent manager'),
			'somethingWentWrong': fox.i18n.getTranslation('somethingWentWrong', 'Oops! Something went wrong. Please try again.')
		};

		return translation[alias] || '';
	};

    fox.registerWidget('CookiePolicyPage', {
        
        configure() {
            this.registerOptions('', {
                template: 'promo_cookie_policy',
                cookieGroups: ['cookiesPerformance', 'cookiesFunctional'],
                widgets: {
                    popup: {
                        widget: 'PopupWidget',
						useUiPosition: true,
						dialog: {
							title: getTranslation('cookieConsentManagerTitle'),
							width: '700px',
							dialogClass: 'dlg-amc dark-overlay cookie-consent-popup'
						},
						widgets: {
							content: {
								widget: 'Widget',
								autoRender: false,
								template: 'consent_manager_tool',
								'hooks.onStopEmbedToDom': function() {
									if (this.element.length === 2) {
										this.element = [this.element[0]];
									}
								}
							}
						}
                    }
                },
                handleDom: {
                    showCookiesPopup: {
                        target: '#show-cookies-popup',
                        callback: 'showPopup'
                    },
                    submit: {
						targetWidget: '#popup #content',
						target: '.apply',
						event: 'click',
						callback: 'submit'
					}
				},
				handleWom: {
					showPopup: {
						widget: '@root #gdprCookieBanner',
						event: 'showCookiesPreferences',
						callback: 'showPopup'
					}
				}
            });

            this.callParent('configure', arguments);
        },

        running() {
            this.callParent('running', arguments);

			this.popup = this.wom1('#popup');

			// if (this.checkHash()) {
			// 	this.showPopup();
			// }
		},
		
		activate() {
			if (this.checkHash()) {
				this.showPopup();
			}

			this.callParent('activate', arguments);
		},

        showPopup() {
			this.popup.show();
			this.setConsentData();
        },

        submit (el, w, alias, e) {
			e.preventDefault();
			
			const params = this.getConsentData();
			const l = window.location;
			const gdprCookieWidget = fox.wom.selectFirst('@root #gdprCookieBanner');

			this.removeCookies(params);
			this.popup.hide();

			// gdprCookieWidget.acceptCookies();
			gdprCookieWidget.saveToStorage();
			
			fox.Consent.setSettings(params).then(() => {
				l.assign(l.pathname);
			});
        },
        
        setConsentData () {
			const content = this.popup.rwom1('#content');

			// if (content._indom !== true) {
			// 	this.wait(content, 'addedToDom', {prefix: `${this.getAlias()}_atd_${new Date().getTime()}`}).then(() => {
			// 		this.setConsentData();
			// 	});

			// 	return;
			// }

			this.wait(content, 'addedToDom', {prefix: `${this.getAlias()}_atd_${new Date().getTime()}`}).then(() => {
				this.setConsentData();
			});

			if (content._indom !== true) {
				return;
			}
		
			fox.each(this.getOption('cookieGroups'), (item) => {
				let switcher = content.dom1('.' + item),
					el = content.dom1('.' + item + ' input');
				
				fox.dom.removeClass('disabled', switcher);
				
				el.disabled = false;

				// console.log(el);
				
				fox.Consent.check(item).then((data) => {
					el.checked = !!data;
				}).catch(() => {
					el.checked = false;
				});
			});
		},

		getConsentData () {
			let data = {cookiesStrict: 1};
			
			fox.each(this.getOption('cookieGroups'), (item) => {
				let el = this.popup.wom1('#content').dom1('.' + item + ' input');
				data[item] = el.checked ? 1 : 0;
			});
			
			return data;
		},

		removeCookies (groups) {
			fox.each(groups, (value, name) => {
				if (Number(value) === 0) {
					fox.Consent.removeCookies(name);
				}
			})
		},

		checkHash() {
			const hash = window.location.hash.replace('#', '');

			return (hash && hash === 'withdrawal-popup');
		}

    }, 'Widget');

}


// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/components/consent/widget/page.es.js